import qs from 'qs';
import { PLATFORM_EXTENSIONS } from '@constants';

export const GET_PROMOS_SUCCESS = 'header/GET_PROMOS_SUCCESS';
export const GET_PROMOS_FAILURE = 'header/GET_PROMOS_FAILURE';

const onSuccess = promos => ({
  type: GET_PROMOS_SUCCESS,
  payload: { promos },
});

const onFailure = () => ({
  type: GET_PROMOS_FAILURE,
});

const getRequestUrlParams = (userId, isNewUser, isB2B) => {
  const requestParams = {};

  if (userId) {
    requestParams.user_id = isB2B ? userId : 0;
  }

  if (isNewUser !== undefined) {
    requestParams.new_user = isNewUser;
  }

  return requestParams;
};

export const getPromosAction = (
  baseUrl,
  platformId,
  isB2B,
  userId,
  isNewUser,
) => {
  const marketId = isB2B ? 'B2B' : 'B2C';
  const path = 'api/v1/campaigns';
  const slug = 'onglet_banner';

  const requestParams = getRequestUrlParams(userId, isNewUser, isB2B);

  const upperCasePlatform = platformId.toUpperCase();
  const platformExtension = PLATFORM_EXTENSIONS[upperCasePlatform];
  // Replacing .com by .platform to make use of the cached kong call
  const platformBaseUrl = platformExtension
    ? baseUrl.replace('.com', platformExtension)
    : baseUrl;

  let url = `https://${platformBaseUrl}/${path}/${upperCasePlatform}/${marketId}/${slug}`;
  if (Object.keys(requestParams).length) {
    url = url.concat(`?${qs.stringify(requestParams)}`);
  }

  return {
    payload: {
      url,
      method: 'GET',
      onSuccess,
      onFailure,
    },
  };
};
